<template>
    <v-app>
        <v-app-bar
            app
            color="#F24653"
            dark
            dense
        >
            <v-toolbar-title>
                <slot name="title">RedChirp Chat Widget: Pixel Code</slot>
            </v-toolbar-title>
        </v-app-bar>
        <v-container>
            <v-card
                style="margin-top: 60px"
            >
                <v-card-subtitle
                    style="font-family: Roboto; font-size: 15px"
                >
                    To display the RedChirp widget on your site, you need to include the following code.
                    The code may be placed anywhere in the body of the page (that is, between the open and close body tags).
                    The code must be placed on <em>every</em> page where you would like the widget to show.
                </v-card-subtitle>
                <div
                    style="padding: 15px"
                >
                    <m-code-block>
                        {{pixel_code}}
                    </m-code-block>
                </div>
            </v-card>
        </v-container>
    </v-app>
</template>

<script>

export default {
    data() {
        return {
            pixel_code: ''
        }
    },

    mounted () {
        this.getWidgetPixelCode();
    },

    methods: {
        getWidgetPixelCode() {
            this.$rc.getWidgetCode(
                (data) => {
                    this.pixel_code = data.pixel_code;
                },
                () => {
                    this.$rc.alert(
                        'Error Retrieving Widget Code',
                        'There was an error retrieving the widget code. Please try again.',
                    );
                }
            );
        },
    }
}
</script>

<style lang="scss" scoped>
</style>